export default {"src":"/_next/static/media/framework-optimization.03a9e623.svg","height":877,"width":1036,"blurWidth":0,"blurHeight":0};